export default "__VITE_ASSET__n1qhYtQ5__"